
    import React from 'react';
    import ZipCodeRangeFormPageContainer from './ZipCodeRangeFormPageContainer';
    
    export class ZipCodeRangeFormPage extends React.Component{
        render(){
            return (
                <ZipCodeRangeFormPageContainer {...this.props}/>
            )
        }
    }
    